import { render, staticRenderFns } from "./WorkArea.vue?vue&type=template&id=1c3f207a&scoped=true"
import script from "./WorkArea.vue?vue&type=script&lang=js"
export * from "./WorkArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f207a",
  null
  
)

export default component.exports